module.exports = __webpack_public_path__ + "static/media/logo_opal.9e4f2cfb.png";